<script>
import { tooltipTop } from '../tooltip';
import Hero from './Hero.svelte';
import { number } from '../libs/helpers';
import { format } from 'date-fns';

window.stopRouter();

let params = new URLSearchParams(location.search.slice(1));
if (params.get('d')) {
  try {
    params = new URLSearchParams(atob(params.get('d')));
  } catch (err){}
}
const query = {};
for(const [key, value] of params) {
  query[key] = value;
}
const sprintTip = `A Word Sprint is a timed challenge where you write as much as you can.`;

function int(value) {
  if (!value) return 0;
  return parseInt(value.replace(/\D/g, ''));
}

function num(value) {
  return number(int(value));
}

function date(value) {
  let date = new Date(value);
  if (isNaN(date)) date = new Date(parseInt(value));
  if (isNaN(date)) return '';
  return format(date, 'PPPp');
}
</script>

<Hero/>

<section>
  <div class="results">
    <div class="box">
      <h1>Sprint Results</h1>
      {#if date(query.start)}
      <div class="date">{date(query.start)}</div>
      {/if}

      <div class="meta">
        <h4 class="sprint-duration">{query.duration.replace(/^[a-z]| [a-z]/g, str => str.toUpperCase()).replace(/s$/, '') + ' Sprint'}</h4>
        <div class="details">
          <div class="detail large" use:tooltipTop={'Sprint word count'}>
            <div class="value">{num(query.count)}</div>
            <div class="label">Words</div>
          </div>
          {#if query.participants}
          <div class="seperator"></div>
          <div class="detail">
            <div class="value">{num(query.participants)}</div>
            <div class="label">Participants</div>
          </div>
          <div class="detail">
            <div class="value">{num(query.total)}</div>
            <div class="label">Group Word Count</div>
          </div>
          <div class="detail">
            <div class="value">{number(Math.round(int(query.total) / int(query.participants)))}</div>
            <div class="label">Average</div>
          </div>
          {/if}
        </div>
      </div>
    </div>

    <div class="recommend">
      <p class="message">
        {#if query.name}
          <span class="name">{query.name}</span> uses
        {:else}
          Writers use
        {/if}
        <span class="wordsprints">Word Sprints</span> to write more.</p>
      <p class="follow-on">For free!</p>
      <p class="link"><a href="/">Start your own Word Sprint now →</a></p>
    </div>
  </div>
</section>

<section class="footer">
	<div class="footer-content">
		© Dabble Writer, Inc.
	</div>
</section>

<style>
.recommend {
  margin-top: 64px;
  text-align: center;
  color: var(--warm-grey-600);
}
.recommend .message {
  margin-bottom: 0;
  font-size: var(--font-size-600);
}
.recommend .follow-on {
  color: var(--warm-grey-800);
  font-size: var(--font-size-200);
  margin-bottom: 32px;
}
.recommend .link {
  text-decoration: underline;
}
.wordsprints {
  font-weight: 100;
}
.box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--white);
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.20), 0 2px 4px 0 rgba(0,0,0,0.20);
  border-radius: 5px;
  padding: 48px;
}
.date {
  position: absolute;
  bottom: 16px;
  right: 16px;
  color: var(--warm-grey-400);
  font-size: var(--font-size-100);
}
.sprint-duration {
  margin-top: 0;
  margin-bottom: 24px;
  font-size: var(--font-size-500);
  color: var(--warm-grey-600);
  text-align: center;
}
.meta {
  display: flex;
  flex-direction: column;
  width: 220px;
}
.details {
  margin-bottom: 24px;
}
.detail {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin: 6px 0;
  font-size: var(--font-size-100);
}
.detail.large {
  font-size: var(--font-size-400);
}
.detail .value {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  font-family: var(--font-header);
  font-weight: bold;
  color: var(--warm-grey-700);
  width: 84px;
}
.detail .label {
  width: 120px;
  white-space: nowrap;
  color: var(--warm-grey-500);
}
.seperator {
  border-top: 1px solid var(--warm-grey-100);
  margin: 10px 0;
}
.footer-content {
	margin: 32px auto;
	text-align: center;
	color: var(--warm-grey-400);
	font-size: var(--font-size-100);
	max-width: 660px;
}
</style>
